import ApiRequest from '../request'

export default class Prestas {
  constructor() {
    this.apiRequest = new ApiRequest()
  }

  async getInterventionsByToken(ticket_token, params) {
    try {
      // fetch interventions presta by ticket_token
      const res = await this.apiRequest.get(
        `ext_prestas/interventions/${ticket_token}`,
        params
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async getInfosPrestaByToken(ticket_token, params = {}) {
    try {
      // fetch presta details by ticket_token
      const res = await this.apiRequest.get(
        `ext_prestas/${ticket_token}`,
        params
      )
      return res
    } catch (error) {
      return error.response
    }
  }
  async updateInfosPresta(ticket_token, data) {
    try {
      // update presta details by ticket_token
      const res = await this.apiRequest.put(`ext_prestas/${ticket_token}`, data)
      return res
    } catch (error) {
      return error.response
    }
  }
  async getListPrestas(params) {
    try {
      const res = await this.apiRequest.get(`prestas`, params)
      return res
    } catch (error) {
      return error.response
    }
  }
}
